import React, { useEffect, useCallback, useState } from "react";
import { useUserInfoStore } from "@/models/userInfo";
import loadjs from "loadjs";
import clsx from "clsx";
import { jwtDecode } from "jwt-decode";
import { googleSignInAPI, appleSignInAPI, getUserInfo } from "@/services/login";
import { track } from "@/lib/log";

const googleClientId =
    '640964063331-kf44nklondsrrhd2jl7apgsduqv8uq5o.apps.googleusercontent.com';
function ampLog(message: string, data: any) {
    console.log(message, data);
}
function useDeviceInfo() {
    return [{
        os: {
            name: "web"
        }
    }]
}
export const CURRENT_APP_ID = 'community';

let firebase: any;

const firebaseConfig = {
    apiKey: "AIzaSyD4YRTWt6zDSOmauMTSDLXtThW3L18uiVI",
    authDomain: "community-aad54.firebaseapp.com",
    databaseURL: "https://community-aad54-default-rtdb.firebaseio.com",
    projectId: "community-aad54",
    storageBucket: "community-aad54.firebasestorage.app",
    messagingSenderId: "261115290842",
    appId: "1:261115290842:web:18befc2c9755ae26fe71e3",
    measurementId: "G-ZELEMHKCRC"
};

interface Props {
    onSuccess: () => void;
    onLoadingChange: (loading: boolean) => void;
}

const GoogleIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 48 48"
            width="22"
            height="22"
        >
            <path
                fill="#FFC107"
                d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"
            />
            <path
                fill="#FF3D00"
                d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"
            />
            <path
                fill="#4CAF50"
                d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"
            />
            <path
                fill="#1976D2"
                d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"
            />
        </svg>
    )
};

const AppleIcon = () => {
    return (
        <svg fill="#000000" width="22px" height="22px" viewBox="-52.01 0 560.035 560.035" xmlns="http://www.w3.org/2000/svg"><path d="M380.844 297.529c.787 84.752 74.349 112.955 75.164 113.314-.622 1.988-11.754 40.191-38.756 79.652-23.343 34.117-47.568 68.107-85.731 68.811-37.499.691-49.557-22.236-92.429-22.236-42.859 0-56.256 21.533-91.753 22.928-36.837 1.395-64.889-36.891-88.424-70.883-48.093-69.53-84.846-196.475-35.496-282.165 24.516-42.554 68.328-69.501 115.882-70.192 36.173-.69 70.315 24.336 92.429 24.336 22.1 0 63.59-30.096 107.208-25.676 18.26.76 69.517 7.376 102.429 55.552-2.652 1.644-61.159 35.704-60.523 106.559M310.369 89.418C329.926 65.745 343.089 32.79 339.498 0 311.308 1.133 277.22 18.785 257 42.445c-18.121 20.952-33.991 54.487-29.709 86.628 31.421 2.431 63.52-15.967 83.078-39.655" /></svg>
    )
}

const SsoSignin = (props: Props) => {
    const [requesting, setRequesting] = useState(false);
    const { setUserInfo, setIsLogin } = useUserInfoStore();
    const [loading, setLoading] = useState(true);
    const [signInInfo, setSignInInfo] = useState<{ name: string; avatar?: string, email: string, providerId: string } | null>(null);
    const [deviceInfo] = useDeviceInfo();

    const osName = deviceInfo?.os.name;
    const isAndroid = osName && osName.toLowerCase() === "android";

    // 新增：登录按钮loading状态
    const [btnLoading, setBtnLoading] = useState<"google" | "apple" | null>(null);

    const onSuccess = (res?: any, type?: string) => {
        if (res?.userType !== "webguest" && res?.userid) {
            setUserInfo(res);
            setIsLogin(true);
            setLoading(false);
            track("signinSuccess", { type: res?.userType, isLogin: res?.isLogin });
        } else {
            alert(
                type === "google"
                    ? "Login with Google failed. Please check your Chrome login status."
                    : "Login Failed"
            );
        }
        setBtnLoading(null);
        props.onSuccess();
    };

    const googleSignIn = (
        accessToken: string,
        expiresIn: string,
        googleId: string
    ) => {
        if (requesting) return;
        setRequesting(true);
        setBtnLoading("google");
        track("signin", { type: "google" });
        props.onLoadingChange(true);
        return googleSignInAPI(accessToken, expiresIn, googleId)
            .then((res: any) => {
                onSuccess(res, "google");
            })
            .catch((e: any) => {
                console.warn(e);
                onSuccess(undefined, "google");
            })
            .finally(() => {
                setRequesting(false);
                setBtnLoading(null);
                props.onLoadingChange(false);
            });
    };

    const googleSignInSuccess = useCallback(() => {
        if (btnLoading) return;
        setBtnLoading("google");
        setLoading(true);
        firebase
            .auth()
            .signInWithPopup(new firebase.auth.GoogleAuthProvider())
            .then((result: any) => {
                const credential = result.credential;
                // @ts-ignore
                const token = credential?.idToken;
                const user = result.additionalUserInfo;
                // @ts-ignore
                googleSignIn(token, "3600", user?.profile?.id);
            })
            .catch((e: any) => {
                setBtnLoading(null);
                setLoading(false);
                alert(
                    "There is a problem. Please try again later"
                );
            });
    }, [btnLoading]);

    const appleSignIn = (
        accessToken: string,
        expiresIn: string,
        appleId: string
    ) => {
        if (requesting) return;
        setRequesting(true);
        setBtnLoading("apple");
        track("signin", { type: "apple" });
        props.onLoadingChange(true);
        return appleSignInAPI(accessToken, expiresIn, appleId)
            .then((res: any) => {
                onSuccess(res, "apple");
            })
            .catch((e: any) => {
                console.warn(e);
                onSuccess(undefined, "apple");
            })
            .finally(() => {
                setRequesting(false);
                setBtnLoading(null);
                props.onLoadingChange(false);
            });
    };

    const appleSignInSuccess = useCallback(() => {
        if (btnLoading) return;
        setBtnLoading("apple");
        setLoading(true);
        const provider = new firebase.auth.OAuthProvider("apple.com");
        provider.addScope("email");
        provider.addScope("name");
        props.onLoadingChange(true);
        firebase
            .auth()
            .signInWithPopup(provider)
            .then((result: any) => {
                const credential = result.credential;
                // @ts-ignore
                const token = credential?.idToken;
                const user = result.additionalUserInfo;
                // @ts-ignore
                appleSignIn(token, "3600", user?.profile?.id ?? result.user?.uid ?? "");
            })
            .catch((error: any) => {
                setBtnLoading(null);
                setLoading(false);
                alert(
                    "Login with Apple failed. Please check your Chrome login status."
                );
            })
            .finally(() => {
                setLoading(false);
                props.onLoadingChange(false);
            });
    }, [btnLoading]);

    useEffect(() => {
        setLoading(true);
        loadjs("https://accounts.google.com/gsi/client", () => {
            const handleToken = (response: any) => {
                var token = response.credential;
                var decodedJson = jwtDecode(token);
                // @ts-ignore
                const { sub } = decodedJson;
                googleSignIn(token, "3600", sub ?? "");
            };
            const client_id = googleClientId;
            const callback = handleToken;
            // @ts-ignore
            window.google.accounts.id.initialize({
                client_id,
                callback,
                context: "signin",
            });
            getUserInfo().then((res) => {
                if (!res?.data?.isLogin) {
                    // @ts-ignore
                    window.google.accounts.id.prompt();
                }
            });
        });
    }, []);

    useEffect(() => {
        setLoading(true);
        // @ts-ignore
        if (window.firebase) {
            setLoading(false);
            return;
        }
        loadjs(
            [
                "https://www.gstatic.com/firebasejs/8.7.1/firebase-app.js",
                "https://www.gstatic.com/firebasejs/8.7.1/firebase-auth.js",
            ],
            () => {
                // @ts-ignore
                firebase = window.firebase;
                if (!firebase.apps.length) {
                    firebase.initializeApp(firebaseConfig);
                } else {
                    firebase.app(); // if already initialized, use that one
                }
                setLoading(false);

                // @ts-ignore
                firebase.auth().onAuthStateChanged((user) => {
                    console.log("🚀 ~ firebase.auth ~ user:", user)
                    if (user) {
                        // User is signed in
                        const { displayName, photoURL, email, providerData } = user;
                        let providerId = "google.com";
                        if (providerData && providerData.length > 0) {
                            const provider = providerData[0];
                            providerId = provider.providerId;
                        }

                        setSignInInfo({
                            name: displayName,
                            avatar: photoURL,
                            email: email,
                            providerId: providerId
                        });
                    }
                })
            }

        );
    }, []);

    return (
        <>
            <div className="flex flex-col gap-2 w-full">
                {loading ? (
                    <div className="flex justify-center items-center w-full h-[100px] bg-gray-100 rounded-lg">
                        <div className="flex items-center space-x-2 text-gray-500">
                            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-gray-700"></div>
                            <span className="text-sm">Loading...</span>
                        </div>
                    </div>
                ) : (
                    <>
                        <div
                            className={clsx(
                                "w-full flex flex-col gap-4"
                            )}
                        >
                            {signInInfo && signInInfo.providerId == "google.com" ?
                                <div
                                    className={clsx(
                                        "flex justify-center items-center gap-2 rounded-full border p-2 bg-gray-100 py-3 cursor-pointer hover:bg-gray-200 border-none",
                                        btnLoading === "google" && "opacity-60 pointer-events-none"
                                    )}
                                    onClick={googleSignInSuccess}
                                >
                                    <div className="flex items-center gap-2">
                                        <GoogleIcon />
                                        <img className="w-6 h-6 rounded-full mx-2" src={signInInfo.avatar} alt="Google Avatar" />
                                        <div className="flex-grow text-xs">
                                            <div className="font-semibold">Continue as {signInInfo.name}</div>
                                            <div className="text-gray-400">{signInInfo.email}</div>
                                        </div>
                                        {btnLoading === "google" && (
                                            <span className="ml-2 w-4 h-4 border-2 border-gray-300 border-t-blue-500 rounded-full animate-spin"></span>
                                        )}
                                    </div>
                                </div>
                                :
                                <div
                                    className={clsx(
                                        "flex justify-center items-center gap-2 rounded-full border p-2 bg-gray-100 py-3 cursor-pointer hover:bg-gray-200 border-none",
                                        btnLoading === "google" && "opacity-60 pointer-events-none"
                                    )}
                                    onClick={googleSignInSuccess}
                                >
                                    <div className="flex items-center gap-2">
                                        <GoogleIcon />
                                        <span>Continue with Google</span>
                                        {btnLoading === "google" && (
                                            <span className="ml-2 w-4 h-4 border-2 border-gray-300 border-t-blue-500 rounded-full animate-spin"></span>
                                        )}
                                    </div>
                                </div>
                            }
                            {!isAndroid &&
                                <>
                                    {signInInfo && signInInfo.providerId == "apple.com" ?
                                        <div
                                            className={clsx(
                                                "flex justify-center items-center gap-2 rounded-full border p-2 bg-gray-100 py-3 cursor-pointer hover:bg-gray-200 border-none",
                                                btnLoading === "apple" && "opacity-60 pointer-events-none"
                                            )}
                                            onClick={appleSignInSuccess}
                                        >
                                            <div className="flex items-center gap-2">
                                                <AppleIcon />
                                                <div className="flex-grow text-xs">
                                                    <div className="font-semibold">Continue as {signInInfo.name}</div>
                                                    <div className="text-gray-400">{signInInfo.email}</div>
                                                </div>
                                                {btnLoading === "apple" && (
                                                    <span className="ml-2 w-4 h-4 border-2 border-gray-300 border-t-blue-500 rounded-full animate-spin"></span>
                                                )}
                                            </div>
                                        </div>
                                        :
                                        <div
                                            className={clsx(
                                                "flex justify-center items-center gap-2 rounded-full border p-2 bg-gray-100 py-3 cursor-pointer hover:bg-gray-200 border-none",
                                                btnLoading === "apple" && "opacity-60 pointer-events-none"
                                            )}
                                            onClick={appleSignInSuccess}
                                        >
                                            <div className="flex items-center gap-2">
                                                <AppleIcon />
                                                <span>Continue with Apple</span>
                                                {btnLoading === "apple" && (
                                                    <span className="ml-2 w-4 h-4 border-2 border-gray-300 border-t-blue-500 rounded-full animate-spin"></span>
                                                )}
                                            </div>
                                        </div>
                                    }
                                </>
                            }
                        </div>
                    </>
                )}
            </div>
        </>
    );
};
export default SsoSignin;
